import React from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@material-ui/core";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Companies from "./pages/admin/Companies";
import Callcenter from "./pages/admin/Callcenter";
import StaffSignin from "./pages/Signin";
import Catagories from "./pages/admin/Catagories";
import Index from "./pages/callcenter/CallCenter";
import CompanyList from "./components/CompanyList";
import SubCatagoryComponent from "./components/SubCatagoryComponent";
import SearchCompany from "./pages/callcenter/SearchCompany";
import CompanyDetail from "./pages/admin/CompanyDetail";
import CompanyDetailcallcenter from "./pages/callcenter/CompanyDetailcallcenter";
import ManageNews from "./pages/admin/News";
import Users from "./pages/admin/Users";
import { isAuth } from "./actions/auth";
import Ads from "./pages/admin/Ads";
import Dashboard from "./pages/admin/Dashboard";
import CompanyDashboard from "./pages/admin/CompanyDashboard";
import Managerequests from "./pages/admin/Managerequests";
import StaffSignup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import CompanyNews from "./pages/admin/CompanyNews";
import CompanyJobs from "./pages/admin/CompanyJobs";
import JobRequests from "./pages/admin/JobRequests";
import NewsRequests from "./pages/admin/NewsRequests";
import CompanySignup from "./pages/CompanySignup";
import CompanySignin from "./pages/CompanySignin";
import RoleManagement from "./pages/admin/RoleManagement";
import MenuManagement from "./pages/admin/MenuManagement";

const theme = createTheme({
  // ... (skipping theme for brevity, matching existing)
  palette: {
    primary: {
      main: "rgba(244,151,3,.8)",
      light: "rgba(183, 42, 56, 0.788)",
      contrastText: "#fff",
    },
    secondary: {
      main: "rgb(20,61,89)",
      light: "#f8324526",
      contrastText: "#fff",
    },
    background: {
      default: "#f4f5fd",
    },
  },
  overrides: {
    MuiAppBar: {
      root: {
        shadow: "0",
      },
    },
  },
  props: {
    MuiIconButton: {
      disableRipple: true,
    },
  },
});

const App = () => {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => {
              return isAuth() ? (
                <Redirect to="/admin" />
              ) : (
                <Redirect to="/staff/signin" />
              );
            }}
          />
          <Route
            path="/admin"
            exact
            render={(props) => (isAuth() ? <Dashboard {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/company"
            exact
            render={(props) => (isAuth() ? <Companies {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/callcenter"
            render={(props) => (isAuth() ? <Callcenter {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/catagories"
            render={(props) => (isAuth() ? <Catagories {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/role"
            render={(props) => (isAuth() ? <RoleManagement {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/menus"
            render={(props) => (isAuth() ? <MenuManagement {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/company/:Id"
            render={(props) => (isAuth() ? <CompanyDetail {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/news"
            render={(props) => (isAuth() ? <ManageNews {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/users"
            render={(props) => (isAuth() ? <Users {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/ads"
            render={(props) => (isAuth() ? <Ads {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/requests"
            render={(props) => (isAuth() ? <Managerequests {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/company-dashboard"
            render={(props) => (isAuth() ? <CompanyDashboard {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/all-company-news"
            render={(props) => (isAuth() ? <CompanyNews {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/company-news"
            render={(props) => (isAuth() ? <NewsRequests {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/all-jobs"
            render={(props) => (isAuth() ? <CompanyJobs {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route
            path="/admin/jobs"
            render={(props) => (isAuth() ? <JobRequests {...props} /> : <Redirect to="/staff/signin" />)}
          />
          <Route path="/staff/signin" component={StaffSignin} />
          <Route path="/staff/forgot-password" component={ForgotPassword} />
          <Route path="/company/signup" component={CompanySignup} />
          <Route path="/company/signin" component={CompanySignin} />
          <Route path="/callcenter" component={Index} />
          <Route path="/companylist/:catagoryId" component={CompanyList} />
          <Route
            path="/subcatagory/:catagoryId"
            component={SubCatagoryComponent}
          />
          <Route
            exact
            path="/company/:Id"
            component={CompanyDetailcallcenter}
          />
        </Switch>
        <CssBaseline />
      </ThemeProvider>
    </Router>
  );
};

export default App;
